import { render, staticRenderFns } from "./PublicationPage.vue?vue&type=template&id=04eb47a3&scoped=true"
import script from "./PublicationPage.vue?vue&type=script&lang=js"
export * from "./PublicationPage.vue?vue&type=script&lang=js"
import style0 from "./PublicationPage.vue?vue&type=style&index=0&id=04eb47a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb47a3",
  null
  
)

export default component.exports